// extracted by mini-css-extract-plugin
export default {"ReviewsTitle":"iStyles_ReviewsTitle__TRl3k","ReviewsSubtitle":"iStyles_ReviewsSubtitle__092h4"};